// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

export const FEDEX_PRODUCTION_TOKEN = "J5Nvjb7O9t8t5nZ0dQlI";
